import request from '@/config/axios'

// 上传接口返回
export type FileUploadRespVO = {
  url: string // 文件访问地址
  name: string // 文件名
  type: string // 文件类型
  size: number // 文件大小（字节）
}

/**
 * 上传文件（后端文件微服务，无需 token）
 * @param file 待上传文件
 * @param onProgress 上传进度回调，参数为 0-100 的整数。
 *   注意：进度反映的是「浏览器把数据发出去」的比例，到 100 后还要等服务端处理完才 resolve，
 *   所以调用方应在 100 之后继续保持 loading，直到 Promise 完成。
 *   uploadApply注册上传文件接口
 */
export const uploadFile = (file: File, onProgress?: (percent: number) => void) => {
  const formData = new FormData()
  formData.append('file', file)
  return request.upload<{ data: FileUploadRespVO }>({
    url: '/infra/file/uploadNew',
    data: formData,
    timeout: 0, // 上传不限时，避免大文件/弱网下被全局 timeout 打断
    onUploadProgress: (e: ProgressEvent) => {
      if (!onProgress) return
      // total 为 0 或缺失时（部分代理不返回 Content-Length）无法计算百分比，跳过
      if (!e.total) return
      onProgress(Math.min(99, Math.round((e.loaded / e.total) * 100)))
    }
  })
}

export const uploadApply = (file: File, onProgress?: (percent: number) => void) => {
  const formData = new FormData()
  formData.append('file', file)
  return request.upload<{ data: FileUploadRespVO }>({
    url: '/infra/file/uploadApply',
    data: formData,
    timeout: 0, // 上传不限时，避免大文件/弱网下被全局 timeout 打断
    onUploadProgress: (e: ProgressEvent) => {
      if (!onProgress) return
      // total 为 0 或缺失时（部分代理不返回 Content-Length）无法计算百分比，跳过
      if (!e.total) return
      onProgress(Math.min(99, Math.round((e.loaded / e.total) * 100)))
    }
  })
}

